module.exports = __webpack_public_path__ + "static/media/Rebeka foto.15ee55c5.jpg";